// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DeviceModelScreen_buttonsContainer__Dw4+Z","button":"DeviceModelScreen_button__ltQas"};